
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_qk3ao_161",
  "arrow": "awsui_arrow_18eso_qk3ao_161",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_qk3ao_221",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_qk3ao_221",
  "has-caret": "awsui_has-caret_18eso_qk3ao_257",
  "placeholder": "awsui_placeholder_18eso_qk3ao_260",
  "pressed": "awsui_pressed_18eso_qk3ao_273",
  "disabled": "awsui_disabled_18eso_qk3ao_276",
  "in-filtering-token": "awsui_in-filtering-token_18eso_qk3ao_221",
  "readonly": "awsui_readonly_18eso_qk3ao_292",
  "invalid": "awsui_invalid_18eso_qk3ao_314",
  "warning": "awsui_warning_18eso_qk3ao_323",
  "inline-tokens": "awsui_inline-tokens_18eso_qk3ao_332"
};
  